import { supabase } from '../utils/supabase';

/**
 * Load completed games for matchmaking matchHistory (same shape as useCourtManagement).
 * @param {string} sessionId
 * @returns {Promise<Array<{ players: string[], teams: string[][], result: string, score: object, timestamp: string, gameId: string }>>}
 */
export async function fetchMatchHistoryForSession(sessionId) {
  if (!sessionId) return [];

  const { data: games, error: gamesError } = await supabase
    .from('session_games')
    .select('id, created_at, end_time, team_1_score, team_2_score, winning_team')
    .eq('session_id', sessionId)
    .order('end_time', { ascending: true })
    .order('created_at', { ascending: true });

  if (gamesError) throw gamesError;
  if (!games || games.length === 0) return [];

  const gameIds = games.map((game) => game.id);
  const { data: playerGames, error: playerGamesError } = await supabase
    .from('players_session_games')
    .select('session_game_id, player_id, team_number')
    .in('session_game_id', gameIds);

  if (playerGamesError) throw playerGamesError;

  const playersByGameId = {};
  (playerGames || []).forEach((pg) => {
    if (!playersByGameId[pg.session_game_id]) {
      playersByGameId[pg.session_game_id] = { team1: [], team2: [] };
    }
    if (pg.team_number === 1) {
      playersByGameId[pg.session_game_id].team1.push(pg.player_id);
    } else if (pg.team_number === 2) {
      playersByGameId[pg.session_game_id].team2.push(pg.player_id);
    }
  });

  return games
    .map((game) => {
      const teams = playersByGameId[game.id] || { team1: [], team2: [] };
      const team1 = teams.team1 || [];
      const team2 = teams.team2 || [];
      if (team1.length === 0 && team2.length === 0) {
        return null;
      }
      return {
        players: [...team1, ...team2],
        teams: [team1, team2],
        result:
          game.winning_team === 1
            ? 'team1'
            : game.winning_team === 2
              ? 'team2'
              : 'draw',
        score: {
          team1Score: Number(game.team_1_score) || 0,
          team2Score: Number(game.team_2_score) || 0,
        },
        timestamp: game.end_time || game.created_at || new Date().toISOString(),
        gameId: game.id,
      };
    })
    .filter(Boolean);
}
